import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CategoriesComponent } from './pages/categories/categories.component';
import { MasterPageComponent } from './pages/master-page/master-page.component';
import { LoginComponent } from './navigation/login/login.component';
import { HomeComponent } from './pages/home/home.component';
import { AuthGuard } from './auth.guard';  // Import the AuthGuard

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: '',
    component: HomeComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'category',
    component: CategoriesComponent,
    canActivate: [AuthGuard]  // Protect this route with AuthGuard
  },
  {
    path: 'category/:category_id',
    component: MasterPageComponent,
    canActivate: [AuthGuard]  // Protect this route with AuthGuard
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
